<template>
  <div class="layout my-contacts">
    <div class="tab_nav">
      <div class="nav_item" :class="{ is_active: index == actIndex }" @click="tabChange(index)" v-for="(item, index) in navList" :key="index">{{ item }}</div>
    </div>
    <div class="tab_content">
      <productList v-if="actIndex == 0"></productList>
      <activityList v-if="actIndex == 1"></activityList>
      <exhibitorList v-if="actIndex == 2"></exhibitorList>
      <!-- <exhibitionList v-if="actIndex==3"></exhibitionList> -->
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import productList from "./components/product-list"; //展品
import activityList from "./components/activity-list"; //活动
import exhibitorList from "./components/exhibitor-list"; //展商
// import exhibitionList from "./components/exhibition-list";//展会
export default {
  name: "my-contacts",
  components: {
    productList,
    activityList,
    exhibitorList,
    // exhibitionList
  },
  data() {
    return {
      actIndex: 0,
      // navList:['Product','Activity','Exhibitor','展会'],
      navList: ["Product", "Activity", "Exhibitor"],
    };
  },
  async created() {
    this.$store.commit("setExhibitionId", this.$route.params.id);
    if (!this.userInfo) {
      await this.$Myapollo.getUserInfo(this);
    }
    this.$Myapollo.addExhibitionView();
    this.actIndex = this.myCollectHead;
  },
  mounted() {},
  computed: {
    ...mapGetters({
      myCollectHead: "getMyCollectHead",
      userInfo: "getUserInfo",
    }),
  },
  methods: {
    tabChange(i) {
      if (this.actIndex == i) {
        return;
      }
      this.actIndex = i;
      this.$Myapollo.addExhibitionView();
      this.$store.commit("setMyCollectHead", i);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-contacts {
  background: #fff;
  padding: 0.9rem 0 0;
  .tab_nav {
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    height: 0.9rem;
    width: 100%;
    display: flex;
    z-index: 99;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.45rem;
    border-bottom: 1px solid #e6e6e6;
    .nav_item {
      color: #666;
      width: 1.2rem;
      height: 0.48rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.48rem;
      font-size: 0.26rem;
      &.is_active {
        color: #fff;
        background: #1890ff;
      }
    }
  }
  .tab_content {
    padding: 0.3rem;
  }
}
</style>
